module.exports = __webpack_public_path__ + "static/img/mscyH5.b16233a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mscyH5.png
// module id = VZvu
// module chunks = 0